import React from "react";
import { Formik, Field, Form } from "formik";
import { Link } from "react-router-dom";
import { ScriptTag } from "seed/helpers";
import { Loading } from "seed/helpers";
import l from "components/util/l";
import StyleColor from "components/util/helpers/StyleColor"


const SignupView = ({ initialValues, error, isLoading, formikRef, onSubmit }) => (
  <main id="content" role="main" class="main pl-0">
    <StyleColor />
    <div class="container-fluid px-3">
      <div class="row">
        <div class="col-lg-6 d-none d-lg-flex justify-content-center align-items-center min-vh-lg-100 position-relative bg-light px-0" data-select2-id="26">
          <div class="position-absolute top-0 left-0 right-0 mt-3 mx-3" data-select2-id="25">
            <div class="d-none d-lg-flex justify-content-between" data-select2-id="24">
              <a href="/">
                <img class="w-100" src="/theme/svg/logos/logo.svg" alt="Logo" style={{ minWidth: "7rem", maxWidth: "7rem" }} />
              </a>
            </div>
          </div>

          <div style={{ maxWidth: "23rem" }}>
            <div class="text-center mb-5">
              <img class="img-fluid" src="/theme/svg/logos/logo.svg" alt="Logo" style={{ width: "15rem" }} />
            </div>

            <div class="mb-5">
              <h2 class="display-5">Impulsa tus proyectos, automatiza tareas y escala tus servicios con workix.</h2>
            </div>

            <ul class="list-checked list-checked-lg list-checked-primary list-unstyled-py-4">
              <li class="list-checked-item">
                <span class="d-block font-weight-bold mb-1">Todo en un solo lugar</span>
                Diseña, ejecuta y gestiona tus flujos de trabajo de inicio a fin.
              </li>

              <li class="list-checked-item">
                <span class="d-block font-weight-bold mb-1">Añade y gestiona tus servicios fácilmente</span>
                Reúne tus tareas, proyectos, cronogramas, archivos y más.
              </li>

              <li class="list-checked-item">
                <span class="d-block font-weight-bold mb-1">Automatiza tus procesos</span>
                Conecta sistemas, ahorra tiempo y elimina tareas repetitivas.
              </li>

              <li class="list-checked-item">
                <span class="d-block font-weight-bold mb-1">Colabora fácilmente</span>
                Gestiona equipos, proyectos, documentos y reportes en tiempo real.
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-6 d-flex justify-content-center align-items-center min-vh-lg-100">
          <div class="w-100 pt-10 pt-lg-7 pb-7" style={{ maxWidth: "25rem", color: "#fff !important" }}>

            <Formik
              innerRef={formikRef}
              initialValues={initialValues}
              onSubmit={onSubmit}
            >
              {() =>
                <Form>
                  <div class="text-center mb-5">
                    <h1 class="display-4 text-light">Comienza ahora</h1>
                    <p className="text-light">{l("¿Ya tienes tienes una cuenta?%VB047")} <Link to="/login" className="ml-1">{l("Inicia sesión%VB048")}</Link></p>
                  </div>

                  <div class="form-group">
                    <label class="input-label d-flex text-light" for="email">
                      {l("Correo electrónico%VB037")} <span className='text-danger ml-1'>*</span>
                    </label>
                    <Field type="email" name="email" id="email"
                      class="form-control form-control-lg" tabindex="1"
                      placeholder="email@address.com" required autofocus="1" />
                  </div>

                  <div class="js-form-message form-group">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="termsCheckbox" name="termsCheckbox" required="" data-msg="Please accept our Terms and Conditions." />
                      <label class="custom-control-label text-light" for="termsCheckbox"> Al registrarme, acepto la <a href="#">Política de Privacidad</a> y los <a href="#">Términos y Condiciones</a></label>
                    </div>
                  </div>

                  <button type="submit" class="btn btn-lg btn-block btn-accent mb-2">
                    Crear mi cuenta
                  </button>
                </Form>
              }
            </Formik>

          </div>
        </div>
      </div>
    </div>

    <ScriptTag content={`
      $('.js-toggle-password').each(function () {
        new HSTogglePassword(this).init()
      });
    `} />

  </main>
)

export default SignupView;